import { Injectable, NgZone } from '@angular/core';
import { ModuleRefreshServiceBase } from 'src/shared/services/module-refresh-service-base';

@Injectable({
  providedIn: 'root'
})
export class ModuleRefreshService extends ModuleRefreshServiceBase {
  constructor(_ngZone: NgZone) {
    super(true, _ngZone);
  }
}
